export default __webpack_public_path__ + "img/catIcon15.2c713783.svg";